/**  period actions constants */
export const SET_LIST_PERIOD = 'period/SET_LIST_PERIOD';